'use client';

import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import {
  COUNTRY_CODE_US,
  CountryCode,
} from '@sola/schema/dotcom/shared/geo.js';

import { usePhoneMask } from '../../utils/masks';
import { InputField, InputFieldProps } from '../input-field/input-field';

export type PhoneFieldProps = InputFieldProps & {
  countryCode: CountryCode;
};

// TODO: Right now we're loading the mask deps when field is in viewport.
// This can prob be optimized so that field deps are only lazy loaded when
// form is interacted with. We can't to this on a field level since inputs can
// be autofilled before masks are applied.
export const PhoneField: React.FC<PhoneFieldProps> = ({
  countryCode = COUNTRY_CODE_US,
  ...fieldProps
}) => {
  const { mask, loadMask } = usePhoneMask(countryCode);
  const { t } = useTranslation();
  const { name } = fieldProps;
  const { trigger } = useFormContext();

  // Trigger validation when the countryCode changes
  useEffect(() => {
    if (!name) {
      return;
    }
    trigger(name);
  }, [countryCode, name]);

  return (
    <InputField
      type="tel"
      placeholder={mask?.placeholder}
      autoComplete="tel"
      onVisible={loadMask}
      {...(!!mask && { maskOptions: mask.options })}
      // TODO we should investigate if there is a smooth way to bypass masked values when validating
      validate={(maskedValue) =>
        countryCode !== 'US' ||
        (!fieldProps.required && !maskedValue) ||
        maskedValue.replace(/\D/g, '').length === 10
          ? true
          : t('core.forms.errors.invalidPhone')
      }
      {...fieldProps}
    />
  );
};
